import { ComponentProps, useCallback, useMemo } from 'react'
import { twMerge } from 'tailwind-merge'
import { toastManager } from '../../toast-store'
import { ToastContext } from './nested/context'
import { ToastContent } from './nested/content'
import { ToastHeader } from './nested/header'
import { ToastTitle } from './nested/title'
import { ToastDescription } from './nested/description'
import { ToastFooter } from './nested/footer'
import { ToastClose } from './nested/close'
import { ToastAction, ToastActions } from './nested/action'
import { ToastIcon, ToastHighlightIcon, ToastHighlightSuccessIcon } from './nested/icon'
import { ToastNotificationToggle } from './nested/notification-toggle'
import { ToastOptions } from './nested/options'
import { ToastOptionsItem } from './nested/options-item'

interface ToastProps extends ComponentProps<'div'> {
  toastId: string
}

function Toast({ toastId, children, className, ...props }: ToastProps) {
  const close = useCallback(() => toastManager.dismiss(toastId), [toastId])
  const ctx = useMemo(() => ({ toastId, close }), [toastId, close])
  return (
    <ToastContext.Provider value={ctx}>
      <div data-slot="Toast" className={twMerge('group relative', className)} {...props}>
        {children}
      </div>
    </ToastContext.Provider>
  )
}

Toast.Content = ToastContent
Toast.Header = ToastHeader
Toast.Title = ToastTitle
Toast.Description = ToastDescription
Toast.Footer = ToastFooter
Toast.Close = ToastClose
Toast.Action = ToastAction
Toast.Actions = ToastActions
Toast.Icon = ToastIcon
Toast.HighlightIcon = ToastHighlightIcon
Toast.HighlightSuccessIcon = ToastHighlightSuccessIcon
Toast.NotificationToggle = ToastNotificationToggle
Toast.Options = ToastOptions
Toast.OptionsItem = ToastOptionsItem

export { Toast }
